export default __webpack_public_path__ + "static/media/ocean-fresh-vessel.192dd785.JPG";